import React, { useEffect, useRef, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import GenericTable from '../../../../Components/GenericTable';
import { Pagination } from '@material-ui/lab';
import CustamizedFilters from '../../../../Components/CustamizedFilters';
import {
    GetApp as GetAppIcon,
    Print,
    Settings,
} from '@material-ui/icons';
import { CircularProgress, IconButton, Input } from '@material-ui/core';
import FilterModal from '../FilterModal';

const useStyles = makeStyles((theme) => ({
    title: {
        color: "#4D5766",
        wordSpacing: 2,
        fontSize: 18,
        [theme.breakpoints.down('xs')]: {
            fontSize: 16,
        },
    },
    headerRow: {
        alignItems: 'center',
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            flexWrap: 'wrap',
        },
    },
    titleCell: {
        [theme.breakpoints.down('xs')]: {
            order: 1,
            width: '100%',
            maxWidth: '100%',
            flexBasis: '100%',
        },
    },
    actionsCell: {
        [theme.breakpoints.down('xs')]: {
            order: 2,
            width: '100%',
            maxWidth: '100%',
            flexBasis: '100%',
            float: 'none',
            display: 'flex',
            justifyContent: 'flex-start',
            marginTop: 4,
        },
    },
    tableWrapper: {
        width: '100%',
        overflowX: 'auto',
        marginTop: theme.spacing(1),
    },
    paginationRow: {
        marginTop: 22,
        marginBottom: 20,
        [theme.breakpoints.down('xs')]: {
            marginTop: 16,
            marginBottom: 16,
        },
    },
    paginationWrap: {
        display: 'flex',
        margin: '0 auto',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 8,
        [theme.breakpoints.down('xs')]: {
            padding: '0 8px',
        },
    },
    goToPageInput: {
        minWidth: 110,
        width: 110,
        marginLeft: 15,
        borderRadius: 8,
        padding: 8,
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0,
            minWidth: 90,
            width: 90,
        },
    },
}));


const DetailsAnalyticsTab = ({
    title,
    filters,
    allFilterState,
    handleChange,
    type,
    pageName,
    columns,
    loading,
    handleItemClick,
    list,
    label,
    handlePageChange,
    handleSubmitFilter,
    handleGoToPage,
    handleDownload,
    downloadReportLoading,
    handlePrint,
    printReportLoading
}) => {

    const [open, setOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState([]);
    const [goToPage, setGoToPage] = useState('');
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    useEffect(() => {
        setGoToPage('');
    }, [list]);

    const handleClose = value => {
        setOpen(false);
        setSelectedValue(value);
    };

    const componentRef = useRef();


    return (
        <>
            <Grid container ref={componentRef} className={classes.headerRow}>
                <Grid item xs={12} sm={8} className={classes.titleCell}>
                    <h4 className={classes.title}>{title}</h4>
                </Grid>

                <Grid item xs={12} sm={4} className={classes.actionsCell}>
                    <h1 id="table_h_icon" style={{ float: "right", margin: 0 }}>
                        <IconButton onClick={handlePrint} aria-label="Print">
                            {printReportLoading[type] ? <CircularProgress color='primary' size={18} /> :
                                <Print color="primary" />}
                        </IconButton>
                        <IconButton aria-label="ExportCSV">
                            {downloadReportLoading[type] ? <CircularProgress color='primary' size={18} /> :
                                <GetAppIcon color="primary" style={{ cursor: 'pointer' }} onClick={handleDownload} />}
                        </IconButton>
                    </h1>
                </Grid>
            </Grid>
            <Grid container ref={componentRef}>
                <CustamizedFilters
                    type={type}
                    filters={filters}
                    pageName={pageName}
                    allFilterState={allFilterState}
                    handleChange={handleChange}
                    handleSubmitFilter={handleSubmitFilter}
                />
                <Grid item xs={12} className={classes.tableWrapper}>
                    <GenericTable
                        columns={columns}
                        loading={loading}
                        left={true}
                        handleItemClick={handleItemClick}
                        list={list}
                        applyMinWidth={false}
                        label={label}
                    />
                </Grid>
            </Grid>
            <Grid container className={classes.paginationRow}>
                <div className={classes.paginationWrap}>
                    {filters?.data_count > 0 && <Pagination
                        size={isMobile ? 'small' : 'medium'}
                        onChange={handlePageChange}
                        showFirstButton
                        showLastButton
                        count={parseInt(Math.ceil(filters.data_count / 10))}
                        variant="outlined"
                        page={(allFilterState?.pageno) ? parseInt(allFilterState.pageno) : 1}
                        shape="rounded"
                    />}
                    {(filters?.data_count > 5) && <Input
                        label={"Go to Page"}
                        disableUnderline
                        className={classes.goToPageInput}
                        placeholder='Page'
                        onKeyDown={evt => {
                            if (evt.key === 'Enter') {
                                handleGoToPage(parseInt(goToPage), type);
                            }
                        }}
                        onChange={evt => {
                            if (evt.target.value && parseInt(evt.target.value) < parseInt(Math.ceil(filters.data_count / 10))) {
                                setGoToPage(parseInt(evt.target.value));
                            } else {
                                setGoToPage('');
                            }
                            return null;
                        }}
                        type={'number'}
                        value={goToPage}
                    />}
                </div>
            </Grid>
            <FilterModal
                selectedValue={selectedValue}
                open={open}
                onClose={handleClose}
                allColumns={columns}
            />
        </>
    );
}

export default DetailsAnalyticsTab;